export var valuesQuestionResultMode = ["ShowRightAnswer", "ShowResult", "ShowNothing"];
/*

*/ 
//# sourceMappingURL=QuestionResultMode.js.map